module.exports = __webpack_public_path__ + "img/new8.62c1cc04.png";